import { CLICKED_BUTTON } from '../actions';
import { EventTypes } from 'redux-segment';

export default function trackButton({ disabled = false, name, step }) {
  if (!step || !name) {
    console.warn('No step or name provided for button');
  }

  return {
    name,
    disabled,
    step,
    type: CLICKED_BUTTON,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: CLICKED_BUTTON,
          properties: {
            disabled,
            name,
            step,
          },
        },
      },
    },
  };
}
